import { useContext } from 'react';
import { AuthContext } from '../contexts/AuthContextCore';

/**
 * useAuth Hook
 *
 * Custom hook to access authentication context
 * Provides easy access to auth state and methods throughout the app
 *
 * Usage:
 * ```jsx
 * const { user, isAuthenticated, signIn, signOut } = useAuth();
 * ```
 *
 * @returns {Object} Authentication context value
 * @throws {Error} If used outside of AuthProvider
 */
export const useAuth = () => {
  const context = useContext(AuthContext);

  if (context === undefined) {
    throw new Error('useAuth must be used within an AuthProvider');
  }

  return context;
};

export default useAuth;
